<ion-item
  class="task-item"
  [ngStyle]="{'--item-color': task.color}"
>

  <ion-label>

    <div class="header">

      <div class="title">{{ task.titulo }}</div>

      <div class="status-wrap">

        @if (task.persistente) {
          <yu-icon name="push-pin"></yu-icon>
        }

        <yu-tag [color]="colorStatus">{{ status }}</yu-tag>

      </div>

    </div>

    <div class="info">

      <yu-icon slot="start" name="clock"></yu-icon>

      <p>
        {{ task.dia | date: 'EEEE, dd MMM' | titlecase }}

        @if (task.hora) {
          <span>{{ 'COMMON.OF_PREPOSITION' | translate }}</span>
        }

        {{ task.hora }} {{ task.hora_fin ? '- ' + task.hora_fin : '' }}
        <sup>{{ task.hora_fin_nexday ? '+1' : '' }} </sup>

        <span>{{ 'COMMON.IN_PREPOSITION' | translate }}</span> {{ task.local }}
      </p>

    </div>

  </ion-label>

</ion-item>
